<template>
  <div class="dealer-locator">
    <div class="columns">
      <div class="column">
        <form @submit.prevent="geocodeAddress">
          <div class="columns">
            <div class="column">
              <div class="field">
                <!-- <label class="label">To find a dealer click the crosshairs or enter an address or postcode.</label> -->
                <label class="label">To find a dealer enter an address or postcode.</label>
                <div class="field">
                <!-- <div class="field has-addons"> -->
                  <div class="control is-expanded">
                    <input type="text" class="input" :placeholder="addressPlaceholder" v-model="addressStr" />
                  </div>
                  <!-- <div class="control" v-if="canGetLocation">
                    <button type="button" class="button" :class="{'is-loading': loadingCurrentPosition}" titile="Use my current location" @click="getDealersNearMe"><font-awesome-icon icon="crosshairs" /></button>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="column is-2">
              <b-field label="Search Radius">
                <b-select v-model="pos.radius" placeholder="Select a search radius" @input="getDealers" expanded>
                  <option v-for="r in radiuses" :value="r" :key="r">{{ r }}</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-2">
              <div class="field">
                <label class="label">&nbsp;</label>
                <button type="submit" class="button" :class="{'is-loading': loadingLocation}">Search Dealers</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="columns">
      <div class="column is-3 map-height scroll-y-auto">
        <div v-if="!premiumDealers.length && !regularDealer.length">
          Enter your address or postcode above to view a list of our dealers closest to you.
        </div>

        <div class="dealer-list premium" v-if="premiumDealers.length">
          <div class="dealer-title flex">
            <div class="flex-1">Premium Stockist</div>
            <button class="button is-small" @click="$dialog.alert({type: 'is-info', title: 'Premium Stockist', message: 'Premium Stockist carry the entire VMS range with live demo units on display.'})">
              <font-awesome-icon icon="question" />
            </button>
          </div>
          <div class="dealer-info" v-for="d in premiumDealers" :key="d.id" @click="showDealer(d)">
            <p><b>{{ d.name }}</b> ({{ d.distance | distance }})</p>
            <p>{{ d.address }}, {{ d.city }} {{ d.state }} {{ d.postcode }}</p>
          </div>
        </div>
        <div class="dealer-list" v-if="regularDealer.length">
          <div class="dealer-title flex">
            <div class="flex-1">Dealer</div>
            <button class="button is-small" @click="$dialog.alert({type: 'is-info', title: 'Dealers', message: 'VMS products are available through our dealer network.'})">
              <font-awesome-icon icon="question" />
            </button>
          </div>
          <div class="dealer-info" v-for="d in regularDealer" :key="d.id" @click="showDealer(d)">
            <p><b>{{ d.name }}</b> ({{ d.distance | distance }})</p>
            <p>{{ d.address }}, {{ d.city }} {{ d.state }} {{ d.postcode }}</p>
          </div>
        </div>
      </div>
      <div class="column map-height">
        <div class="map" ref="mapDiv"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DealerLocator',
  data () {
    return {
      dealers: [],
      radius: 0,
      radiuses: [25, 50, 100, 200, 500],
      pos: { lat: null, lng: null, radius: 50 },
      addressStr: '',
      addressPlaceholder: 'Enter address or postcode',
      canGetLocation: false,
      map: null,
      infoWindow: null,
      mapDefaults: {
        center: { lat: -25.274398, lng: 133.775136 },
        zoom: 4
      },
      categories: [],
      markerIcon: null,
      premiumIcon: null,
      loadingLocation: false,
      loadingCurrentPosition: false
    }
  },
  computed: {
    premiumDealers () {
      return this.dealers.filter(item => item.premium === '1')
    },
    regularDealer () {
      return this.dealers.filter(item => item.premium === '0')
    }
  },
  created () {
    this.$api('getCategories')
      .then(resp => {
        this.categories = resp.data
      })
  },
  mounted () {
    this.canGetLocation = !!navigator.geolocation
    this.map = new google.maps.Map(this.$refs.mapDiv, { // eslint-disable-line no-undef
      center: this.mapDefaults.center,
      zoom: this.mapDefaults.zoom,
      disableDefaultUI: false
    })

    this.premiumIcon = {
      url: 'img/marker-premium.png',
      scaledSize: new google.maps.Size(66 * 0.4, 105 * 0.4) // eslint-disable-line no-undef
    }

    this.markerIcon = {
      url: 'img/marker-dot.png'
    }

    this.infoWindow = new google.maps.InfoWindow() // eslint-disable-line no-undef
  },
  methods: {
    geocodeAddress () {
      this.addressStr = this.addressStr.trim()
      if (!this.addressStr.length) {
        this.$dialog.alert({
          title: 'Dealer Search',
          message: 'Please Enter an address or postcode',
          type: 'is-info'
        })
        return
      }
      this.loadingLocation = true
      this.loadingCurrentPosition = false
      this.addressPlaceholder = 'Enter address or postcode'
      let encodedStr = encodeURIComponent(this.addressStr)
      let url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedStr}&region=au&key=${this.$store.getters.googleApiKey}`
      this.$http.get(url)
        .then(resp => {
          if (resp.data.results.length) {
            this.pos.lat = resp.data.results[0].geometry.location.lat
            this.pos.lng = resp.data.results[0].geometry.location.lng
            this.getDealers()
          } else {
            this.$dialog.alert({
              title: 'Dealer Search',
              message: `Could not find any results for <br />"<em><b>${this.addressStr}</b></em>"`,
              type: 'is-info'
            })
            this.loadingLocation = false
          }
        })
        .catch(err => {
          console.log(err)
          this.loadingLocation = false
        })
    },
    getDealersNearMe () {
      this.loadingCurrentPosition = true
      this.loadingLocation = false
      this.addressPlaceholder = 'Using current location'
      navigator.geolocation.getCurrentPosition(position => {
        this.addressStr = ''
        this.pos.lat = position.coords.latitude
        this.pos.lng = position.coords.longitude
        console.log('got current posigion: ', this.pos)
        this.getDealers()
      })
    },
    getDealers () {
      if (this.pos.lat == null || this.pos.lng == null) {
        this.loadingCurrentPosition = false
        this.loadingLocation = false
        return
      }
      this.$api('locateDealers', this.pos)
        .then(resp => {
          this.setDealers(resp.dealers)
          this.loadingCurrentPosition = false
          this.loadingLocation = false
        })
        .catch(err => {
          console.log(err)
          this.loadingCurrentPosition = false
          this.loadingLocation = false
        })
    },
    setDealers (dealers) {
      if (this.dealers) {
        this.dealers.forEach(d => d.marker.setMap(null))
      }
      this.dealers = dealers
      if (!this.dealers.length) {
        this.map.panTo(this.mapDefaults.center)
        this.map.setZoom(this.mapDefaults.zoom)
        let msg = `No dealers found within ${this.pos.radius}km of `
        if (this.loadingLocation) {
          msg += this.addressStr
        } else if (this.loadingCurrentPosition) {
          msg += 'your current location '
        }

        this.$dialog.alert({
          title: 'Dealear Search',
          message: msg,
          type: 'is-info'
        })
        return
      }
      let latLngBounds = new google.maps.LatLngBounds() // eslint-disable-line no-undef
      for (let d of this.dealers) {
        d.marker = new google.maps.Marker({ // eslint-disable-line no-undef
          title: d.name,
          position: {
            lat: Number(d.lat),
            lng: Number(d.lng)
          },
          icon: d.premium === '1' ? this.premiumIcon : this.markerIcon,
          map: this.map
        })
        d.marker.addListener('click', () => this.showInfoWindow(d))
        latLngBounds.extend(d.marker.position)
      }
      this.map.fitBounds(latLngBounds)
      if (this.map.getZoom() > 14) {
        this.map.setZoom(14)
      }
    },
    showDealer (dealer) {
      if (this.map) {
        this.map.panTo(dealer.marker.position)
        this.map.setZoom(14)
        this.showInfoWindow(dealer)
      }
    },
    showInfoWindow (dealer) {
      let content = `
        <p><b>${dealer.name}</b></p>
        <p>${dealer.address} ${dealer.city} ${dealer.state}
      `
      this.infoWindow.close()
      this.infoWindow.setContent(content)
      this.infoWindow.open(this.map, dealer.marker)
      this.$api('getDealer', { id: dealer.id })
        .then(resp => {
          if (resp.data.web.length) {
            let url = resp.data.web.indexOf('http') === 0 ? resp.data.web : `http://${resp.data.web}`
            content += `<p><b><a href='${url}' target='_blank'>${resp.data.web}</a></b></p>`
          }
          if (resp.data.phone.length) {
            content += `<p><b>phone:</b> ${resp.data.phone}</p>`
          }
          if (resp.data.email.length) {
            content += `<p><b>email:</b> ${resp.data.email}</p>`
          }
          if (resp.data.categories.length) {
            let categories = resp.data.categories.map(item => {
              let cat = this.categories.find(c => c.id === item.id)
              return cat ? cat.name : false
            })
            content += `<p><b>products:</b> ${categories.join(', ')}</p>`
          }
          this.infoWindow.setContent(content)
        })
        .catch(err => {
          console.error(err)
        })
    },
    geolocate () {
      if (navigator.geolocation && this.autocomplete) {
        navigator.geolocation.getCurrentPosition(position => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          var circle = new google.maps.Circle({ // eslint-disable-line no-undef
            center: geolocation,
            radius: position.coords.accuracy
          })
          this.autocomplete.setBounds(circle.getBounds())
        })
      }
    }
  }
}
</script>

<style>
  .dealer-locator {
    padding: 10px 20px;
    margin: 0 auto;
  }

  .dealer-locator .map-height {
    height: 500px;
  }

  .dealer-locator .map {
    height: 100%;
  }

  .dealer-locator .dealer-list {
    margin-bottom: 20px;
  }

  .dealer-locator .dealer-title {
    font-weight: bold;
    font-size: 1.2em;
  }

  .dealer-locator .dealer-info {
    cursor: pointer;
    padding: 5px;
    margin: 5px 0;
    font-size: 0.8em;
    border: solid 1px #999;
  }

  .dealer-locator .dealer-list.premium .dealer-info {
    background-color: red;
    color: white;
  }

  .dealer-locator .dealer-info:hover {
    background-color: #eee;
  }
</style>
